import React from 'react';
import { Link } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import './LegalPage.css';

const PrivacyPage = () => (
  <main className="legal-page">
    <PageTitle title="Privacy" />
    <section className="legal-hero">
      <Link className="legal-back-link" to="/">
        <i className="bi bi-arrow-left" aria-hidden="true" /> Home
      </Link>
      <span className="legal-icon">
        <i className="bi bi-shield-lock" aria-hidden="true" />
      </span>
      <div className="legal-eyebrow">Privacy</div>
      <h1>How MarkazSync handles school information.</h1>
      <p>
        MarkazSync is built for Islamic school and markaz operations. The app helps authorized
        staff manage student, parent, attendance, class, financial, waiting-list, and uploaded
        form records.
      </p>
      <p className="legal-updated">Last updated: September 4, 2026</p>
    </section>

    <section className="legal-content">
      <article>
        <h2>Information we collect</h2>
        <p>
          MarkazSync stores information entered by a school, markaz, or an authorized user. This
          may include student names, class and shift assignments, parent or guardian names and phone
          numbers, teacher and staff account details, attendance records, waiting-list submissions,
          uploaded forms, notes, reports, receipts, and fee or payment records.
        </p>
      </article>
      <article>
        <h2>Registration and contact forms</h2>
        <p>
          Public registration forms may collect a student's name, parent or guardian name, phone
          number, preferred shift, previous markaz, and submission date so the school can review the
          request. Contact forms collect the name, email address, and message needed to respond.
        </p>
      </article>
      <article>
        <h2>How information is used</h2>
        <p>
          Information is used to run school operations: managing classes, recording attendance,
          keeping parent records current, creating reports, handling fee records, and supporting
          administrative workflows. Account emails may be used for login, password reset, new-user
          notices, support replies, and monthly backup delivery when enabled by the school.
        </p>
      </article>
      <article>
        <h2>Email notifications</h2>
        <p>
          MarkazSync may send email for account setup, password resets, contact-form confirmations,
          support replies, and backup delivery when enabled by the school. Email delivery may be
          handled by a third party email provider.
        </p>
      </article>
      <article>
        <h2>Access and protection</h2>
        <p>
          Access is limited by staff role. Admin, teacher, and superuser areas are protected by
          sign-in, and backend routes repeat role checks for security. Staff should protect their
          login and only access records needed for their school responsibilities.
        </p>
      </article>
      <article>
        <h2>Service providers</h2>
        <p>
          MarkazSync may use hosting, database, email, and file-storage providers to operate the
          app. These providers process information only as needed to provide the service,
          troubleshoot delivery, keep the system running, or meet security and legal requirements.
        </p>
      </article>
      <article>
        <h2>Uploads, reports, and exports</h2>
        <p>
          Uploaded forms are intended for markaz administration and should not include information
          that your school is not authorized to collect or retain. Reports, receipts, spreadsheets,
          backups, and exported files should be handled according to school policy because they may
          contain student, parent, attendance, or financial information.
        </p>
      </article>
      <article>
        <h2>Retention and deletion</h2>
        <p>
          Records are kept while they are needed for school operations, reporting, account support,
          backups, or legal obligations. Schools are responsible for reviewing their own records and
          removing outdated uploads, waiting-list entries, and operational data when no longer
          needed.
        </p>
      </article>
      <article>
        <h2>Your choices</h2>
        <p>
          Parents and guardians should contact their school administrator to update contact details,
          correct student records, ask about retained information, or stop school communications.
        </p>
      </article>
      <article>
        <h2>Children's information</h2>
        <p>
          MarkazSync is used by schools and authorized staff, not directly by children. Student
          information should be entered only when the school has permission or another appropriate
          basis to collect and use it for school administration.
        </p>
      </article>
      <article>
        <h2>Contact</h2>
        <p>
          Questions about a specific student's record should go to the school or markaz that entered
          the information. General MarkazSync support requests can be sent through the contact page.
        </p>
      </article>
    </section>
  </main>
);

export default PrivacyPage;
